import React from 'react'
import {useTranslation} from 'react-i18next'

import PFText from 'src/designSystem/components/atoms/PFText/PFText'
import BasicTile from 'src/designSystem/components/molecules/BasicTile/BasicTile'
import Box from 'src/designSystem/components/atoms/Box/Box'
import PFSvgContain from 'src/designSystem/components/atoms/PFSvg/PFSvgContain'
import PayOverTime from 'src/assets/illustrations/PayOverTime.svg'

export type AdvancePendingTileProps = {
  daysUntilCanReapply: number
  testID: string
}

/**
 * A component that displays a notification tile informing the user that their next cash advance
 * is almost ready. It shows how many days remain until the advance will be available.
 *
 * @param props - Component props
 * @param props.daysUntilCanReapply - Number of days until the user can reapply for a new advance
 * @param props.testID - Test ID for component testing
 */
export const AdvancePendingTile: React.FC<AdvancePendingTileProps> = ({
  daysUntilCanReapply,
  testID,
}: AdvancePendingTileProps) => {
  const {t} = useTranslation('AdvancePendingTile')
  return (
    <BasicTile padding="medium" testID={testID}>
      <Box gap={'small'}>
        <PFSvgContain svg={PayOverTime} width={84} />
        <Box align="start" gap={'small'}>
          <PFText variant={'h3'}>{t('title')}</PFText>
          <PFText variant={'p'}>{t('description', {days: daysUntilCanReapply})}</PFText>
        </Box>
      </Box>
    </BasicTile>
  )
}
